<template>
    <b-row id="header_stats_component"
           class="header-stats-component">
        <b-col cols="12" order="0" class="mobile-only stats-element--header">My last income</b-col>
        <b-col cols="12" order="4" class="mobile-only stats-element--header">My last turnover</b-col>
        <b-col lg="4" cols="4" class="stats-element"
               v-for="(stat, index) in stats"
               :key="index" :order="index">
            <div class="stats-element--inside">
                <div class="stats-element--label">
                    <span class="mobile-only">{{ stat.label_mobile }}</span>
                    <span class="desktop-only">{{ stat.label }}</span>
                </div>
                <div class="stats-element--amount">
                    FND {{ stat.value }}
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        dependencies: ['money', 'statistics'],
        computed: {
            stats () {
                return {
                    1: {
                        label: 'My income today',
                        label_mobile: 'Today',
                            value: this.money.format(this.$store.getters.statistics.incomeDaily, 'fnd')
                    },

                    2: {
                        label: 'My weekly income',
                        label_mobile: 'Week',
                            value: this.money.format(this.$store.getters.statistics.incomeWeekly, 'fnd')
                    },
                    3: {
                        label: 'My monthly income',
                        label_mobile: 'Monthly',
                            value: this.money.format(this.$store.getters.statistics.incomeMonthly, 'fnd')
                    },
                    4: {
                        label: 'My turnover today',
                        label_mobile: 'Today',
                            value: this.money.format(this.$store.getters.statistics.turnoverDaily, 'fnd')
                    },
                    5: {
                        label: 'Weekly turnover',
                        label_mobile: 'Week',
                            value: this.money.format(this.$store.getters.statistics.turnoverWeekly, 'fnd')
                    },

                    6: {
                        label: 'My monthly turnover',
                        label_mobile: 'Monthly',
                            value: this.money.format(this.$store.getters.statistics.turnoverMonthly, 'fnd')
                    },
                }
            }
        },
        mounted () {
            this.statistics.fetchData()
        }
    }
</script>

<style lang="scss">
    @import '../../../../../assets/scss/_colors.scss';

    .header-stats-component{
        padding: 0 10px;
    }

    .stats-element{
        padding: 0 6px;
    }

    .stats-element--inside{
        border-width: 0 1px 1px 1px;
        border-color: $base1;
        border-style: solid;
        padding: 9px 15px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 11px;
    }

    .stats-element--header{
        font-size: 15px;
        font-weight: bold;
        color: $base2;

        @media(max-width: 360px){
            padding: 0 6px;
        }
    }

    .stats-element--label,
    .stats-element--amount{
        font-weight: bold;
        color: $base2;
    }

    .stats-element--label{
        font-size: 13px;
    }

    .stats-element--amount{
        font-size: 15px;
    }

    @media(max-width:991px){
        .stats-element--inside{
            padding: 5px;
            flex-direction: column;
            align-items: left;
        }

        .stats-element--label{
            font-size: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/header/bottombar/HeaderStats.vue